package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class LoginStaffResponseModel(
    val staffId: Long = 0L,
    val merchantId: Long = 0L,
    val jwt: String = "",
    val merchantLocationIds: List<Long> = emptyList(),
    val passwordIsTemporary: Boolean = false,
    /** Permission: this staff member can create new bags. Locations are owner-only and never granted to staff. */
    val canCreateBags: Boolean = false,
    /** Permission: this staff member can see the revenue value on the dashboard (otherwise it's masked as "**.**"). */
    val canViewRevenue: Boolean = false
) : BaseResponseModel()
